import { render, staticRenderFns } from "./UserLevelList.vue?vue&type=template&id=65a31bfd&"
import script from "./UserLevelList.vue?vue&type=script&lang=js&"
export * from "./UserLevelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports